var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _path9, _g3, _path10, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFasterMachinesmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-9 0 209 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A3EA2A",
    d: "M18.658 90.646c1.808 0 1.808-2.811 0-2.811s-1.808 2.81 0 2.81ZM75.476 28.385c.909 0 .909-1.405 0-1.405s-.909 1.405 0 1.405ZM113.891 94.676c1.809 0 1.809-2.811 0-2.811-1.808 0-1.808 2.81 0 2.81ZM140.482 26.043c.909 0 .909-1.406 0-1.406-.908 0-.908 1.406 0 1.406ZM176.583 80.433c.909 0 .909-1.405 0-1.405-.908 0-.908 1.405 0 1.405ZM13.552 35.458c.909 0 .909-1.406 0-1.406-.91 0-.91 1.406 0 1.406Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A3EA2A",
    d: "M123.495 110.725H77.771c-2.66 0-4.825-1.855-4.825-4.142v-8.554h1.059v8.554c0 1.696 1.686 3.083 3.766 3.083h45.724c2.071 0 3.767-1.377 3.767-3.083V49.972h1.059v56.611c0 2.287-2.165 4.142-4.826 4.142Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D8DF",
    d: "M74.96 98.908h-2.932v5.369h2.932v-5.369Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M64.148 97.277H48.407v12.668h15.74V97.277Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M100.361 47.225H12.193c-.849 0-1.537.688-1.537 1.537v51.88c0 .848.688 1.536 1.537 1.536h88.168c.849 0 1.537-.688 1.537-1.536v-51.88c0-.849-.688-1.537-1.537-1.537Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M101.889 48.771v47.41H10.647v-47.41c0-.852.693-1.537 1.537-1.537h88.159c.852 0 1.536.694 1.536 1.537h.01Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M44.603 108.86h23.34v1.181c0 .599-.488 1.087-1.087 1.087H45.69c-.6 0-1.087-.488-1.087-1.087v-1.181Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C2538",
    d: "M56.277 100.473a1.536 1.536 0 1 0 .001-3.073 1.536 1.536 0 0 0 0 3.073Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M13.992 92.116V50.627c0-.553.45-1.003 1.003-1.003H97.55c.553 0 1.003.45 1.003 1.003v41.489c0 .759-.637 1.377-1.424 1.377H15.416c-.787 0-1.424-.618-1.424-1.377Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.35
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.096 66.63c-.647-3.392-3.673-5.96-7.28-5.96h-1.284c-.984-4.853-5.228-8.404-10.25-8.404-5.023 0-9.295 3.57-10.26 8.451-3.72.394-6.625 3.523-6.625 7.309 0 4.057 3.336 7.355 7.43 7.355H55.8a1.06 1.06 0 0 0 1.022-1.106 1.062 1.062 0 0 0-1.022-1.021H44.828c-2.933 0-5.313-2.352-5.313-5.247s2.38-5.247 5.313-5.247c1.077 0 2.145.328 3.026.956.422.3.993.262 1.358-.103a1.03 1.03 0 0 0 0-1.471.492.492 0 0 0-.13-.113 7.329 7.329 0 0 0-2.933-1.237c.9-3.72 4.206-6.418 8.104-6.418 4.123 0 7.6 3.008 8.236 7.074a9.89 9.89 0 0 0-.956.572 1.06 1.06 0 0 0-.252 1.461c.037.047.065.094.112.141.365.365.937.403 1.359.103a5.161 5.161 0 0 1 3.026-.956c2.586 0 4.741 1.837 5.219 4.254.094.497.525.853 1.03.853.572 0 1.05-.46 1.06-1.04a.826.826 0 0 0 0-.216l.009.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.016 73.593h-.9v-2.858l.019-.44a4.693 4.693 0 0 1-.319.29l-.496.394-.44-.534 1.377-1.087h.74v4.244l.019-.01ZM64.166 71.493c0 .75-.121 1.303-.365 1.659-.244.356-.618.534-1.124.534-.506 0-.862-.188-1.115-.553-.253-.365-.375-.918-.375-1.64 0-.721.122-1.302.365-1.668.244-.365.619-.534 1.125-.534s.862.188 1.115.563c.262.374.393.927.393 1.64h-.019Zm-2.089 0c0 .525.047.9.14 1.125.094.224.244.346.46.346.215 0 .365-.112.459-.346.093-.235.14-.6.14-1.125 0-.524-.047-.9-.14-1.124-.094-.225-.244-.347-.45-.347-.206 0-.365.113-.46.347-.093.234-.14.6-.14 1.124h-.009ZM60.016 80.095h-.9v-2.858l.019-.44a4.717 4.717 0 0 1-.319.29l-.496.394-.44-.534 1.377-1.087h.74v4.244l.019-.01ZM63.436 80.095h-.9v-2.858l.019-.44a4.693 4.693 0 0 1-.319.29l-.496.394-.44-.534 1.377-1.087h.74v4.244h.01l.009-.01ZM66.865 80.095h-.9v-2.858l.02-.44a4.692 4.692 0 0 1-.32.29l-.496.394-.44-.534 1.377-1.087h.74v4.244l.019-.01ZM70.997 77.977c0 .75-.122 1.302-.366 1.658-.243.356-.618.544-1.124.544-.506 0-.862-.188-1.115-.553-.253-.366-.375-.918-.375-1.64 0-.721.122-1.302.366-1.668.243-.365.618-.534 1.124-.534.506 0 .862.188 1.115.563.262.365.393.918.393 1.64l-.018-.01Zm-2.09 0c0 .524.047.9.14 1.124.094.225.244.347.46.347.215 0 .365-.113.46-.347.093-.234.14-.6.14-1.124 0-.525-.047-.9-.14-1.125-.095-.224-.245-.346-.45-.346-.207 0-.366.112-.46.346-.094.235-.14.6-.14 1.125h-.01ZM72.946 83.102c0 .544-.085.947-.263 1.209-.178.262-.45.393-.824.393-.375 0-.628-.14-.806-.403-.178-.262-.272-.665-.272-1.19 0-.524.085-.955.263-1.208.178-.263.45-.394.824-.394.375 0 .628.14.815.413.188.271.272.674.263 1.19v-.01Zm-1.518 0c0 .384.037.656.094.825.037.15.177.243.337.243.16 0 .262-.084.328-.253.065-.168.103-.44.103-.815 0-.375-.038-.656-.103-.824-.066-.169-.178-.253-.328-.253-.15 0-.263.084-.328.253-.066.168-.103.44-.103.824ZM74.913 84.61h-.674v-2.07l.019-.32a1.527 1.527 0 0 1-.235.207l-.365.281-.328-.394 1.03-.787h.553v3.083ZM59.828 83.14c0 .534-.084.928-.262 1.18-.178.254-.44.385-.806.385-.365 0-.618-.131-.796-.394-.178-.262-.263-.646-.263-1.162 0-.515.084-.927.263-1.18.178-.253.44-.384.796-.384.356 0 .618.131.796.393.178.263.272.656.272 1.172v-.01Zm-1.48 0c0 .366.037.647.093.797.038.14.178.243.328.243.15 0 .263-.084.319-.243.056-.16.103-.431.103-.797 0-.365-.038-.646-.103-.796-.066-.15-.169-.244-.319-.244s-.262.084-.318.244c-.056.159-.113.43-.103.806v-.01ZM61.777 84.61h-.674v-2.023l.018-.31a1.53 1.53 0 0 1-.234.207l-.365.28-.328-.383 1.03-.778h.553v3.008ZM64.691 83.14c0 .534-.084.928-.262 1.18-.178.254-.44.385-.806.385-.365 0-.618-.131-.796-.394-.178-.262-.263-.646-.263-1.162 0-.515.085-.927.263-1.18.178-.253.44-.384.796-.384.356 0 .619.131.797.393.177.263.271.656.271 1.172v-.01Zm-1.48 0c0 .366.037.647.093.797.038.14.178.243.328.243.16 0 .263-.084.319-.243.056-.16.103-.431.103-.797 0-.365-.037-.646-.103-.796-.066-.15-.178-.244-.319-.244-.14 0-.262.084-.318.244-.056.159-.113.43-.103.806v-.01ZM66.574 84.61h-.618v-2.023l.019-.31a1.777 1.777 0 0 1-.216.207l-.337.28-.29-.383.936-.778h.506v3.008ZM59.191 87.009c0 .384-.066.665-.187.853-.122.187-.319.271-.581.271a.648.648 0 0 1-.572-.29c-.13-.188-.187-.469-.187-.844 0-.393.066-.674.187-.852.122-.178.319-.272.572-.272.225-.01.44.094.571.29.122.197.188.478.188.853l.01-.01Zm-1.077 0c0 .272.018.459.065.58.038.132.169.198.3.17.084-.02.14-.085.169-.17.046-.121.065-.308.065-.58 0-.197-.01-.403-.075-.59a.251.251 0 0 0-.29-.17h-.01c-.084.02-.14.085-.168.17a2.532 2.532 0 0 0-.066.59h.01ZM60.559 88.097h-.487v-1.471l.018-.225c-.075.075-.13.131-.168.15l-.262.197-.235-.272.74-.562h.394v2.192-.01ZM65.272 89.735c0 .385-.066.666-.187.853-.122.188-.319.272-.581.272a.648.648 0 0 1-.572-.29c-.131-.188-.187-.47-.187-.844 0-.375.065-.674.187-.853.122-.178.319-.271.572-.271.225-.01.44.093.571.29.14.197.197.478.197.853v-.01Zm-1.068.01c0 .262.019.459.066.571a.25.25 0 0 0 .29.169h.01c.084-.019.14-.084.168-.169.047-.112.066-.309.066-.571 0-.197-.01-.394-.075-.581a.242.242 0 0 0-.235-.178.232.232 0 0 0-.234.178c-.037.112-.065.3-.065.571l.009.01ZM66.64 90.842h-.478V89.37l.019-.225c-.075.075-.131.13-.16.15l-.262.206-.234-.281.722-.563h.393v2.193-.01ZM70.285 86.588c0 .535-.084.928-.263 1.181-.178.253-.44.384-.805.384-.366 0-.619-.131-.797-.393-.178-.263-.262-.647-.262-1.162 0-.516.084-.928.262-1.18.178-.254.44-.385.797-.385.356 0 .618.131.796.394.178.262.272.655.272 1.17v-.009Zm-1.48 0c0 .375.037.647.093.797.038.14.178.243.328.243.15 0 .262-.084.319-.243.056-.16.103-.431.103-.797 0-.365-.038-.646-.103-.805-.066-.16-.178-.244-.328-.244-.15 0-.263.084-.319.244-.056.159-.093.44-.093.815v-.01ZM72.243 88.096h-.674v-2.024l.018-.309a1.524 1.524 0 0 1-.234.206l-.365.281-.328-.384 1.03-.778h.553v3.008ZM75.148 86.588c0 .535-.085.928-.263 1.181s-.44.384-.806.384c-.365 0-.618-.131-.796-.393-.178-.263-.262-.647-.262-1.162 0-.516.084-.928.262-1.18.178-.254.44-.385.796-.385.357 0 .619.131.797.394.178.262.272.655.272 1.17v-.009Zm-1.48 0c0 .375.037.647.093.797.037.14.178.243.328.243.15 0 .262-.084.318-.243.057-.16.103-.431.103-.797 0-.365-.037-.646-.103-.805-.065-.16-.178-.244-.318-.244s-.263.084-.319.244c-.056.159-.103.44-.103.815v-.01ZM70.482 73.593h-.9v-2.858l.019-.44a8.758 8.758 0 0 1-.31.29l-.486.394-.431-.534 1.368-1.087h.74v4.244-.01ZM74.632 71.493c0 .75-.122 1.303-.365 1.659-.244.356-.618.534-1.124.534-.506 0-.862-.188-1.115-.553-.253-.365-.375-.918-.375-1.64 0-.721.122-1.302.365-1.668.244-.365.619-.534 1.125-.534.505 0 .862.188 1.115.563.252.374.384.927.393 1.64h-.019Zm-2.09 0c0 .525.048.9.141 1.125.094.224.244.346.46.346.215 0 .365-.112.459-.346.093-.235.14-.6.14-1.125 0-.524-.047-.9-.14-1.124-.094-.225-.244-.347-.45-.347-.206 0-.365.113-.46.347-.093.234-.14.6-.14 1.124h-.01Z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D4D8DF",
    d: "M129.745 46.9h-3.477v5.368h3.477v-5.369Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M175.665 30.587c-1.265-6.605-7.158-11.628-14.204-11.628h-2.502c-1.911-9.472-10.203-16.396-19.985-16.396s-18.13 6.97-20.014 16.48c-7.252.779-12.92 6.878-12.92 14.261 0 7.918 6.502 14.355 14.485 14.355h21.41a2.06 2.06 0 0 0 1.986-2.146 2.057 2.057 0 0 0-1.986-1.986h-21.391c-5.716 0-10.363-4.591-10.363-10.232 0-5.64 4.647-10.232 10.363-10.232a10.05 10.05 0 0 1 5.903 1.874c.815.59 1.939.506 2.642-.196a2.01 2.01 0 0 0 .009-2.867h-.009a1.386 1.386 0 0 0-.253-.225 14.192 14.192 0 0 0-5.716-2.418c1.753-7.261 8.208-12.508 15.807-12.508 8.039 0 14.823 5.875 16.06 13.792a17.77 17.77 0 0 0-1.856 1.124 2.074 2.074 0 0 0-.271 3.13 2.036 2.036 0 0 0 2.642.196 10.116 10.116 0 0 1 5.903-1.873c5.05 0 9.257 3.579 10.175 8.292a2.058 2.058 0 0 0 2.015 1.667 2.036 2.036 0 0 0 2.052-2.033 1.022 1.022 0 0 0 0-.412l.018-.019Z"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#A3EA2A",
    d: "M43.235 19.896c1.808 0 1.808-2.811 0-2.811s-1.808 2.81 0 2.81ZM2.009 112.656c1.808 0 1.808-2.811 0-2.811-1.809 0-1.809 2.811 0 2.811Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 56.277,
    x2: 56.277,
    y1: 137.745,
    y2: 88.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D4D8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 16.709,
    x2: 198.967,
    y1: 46.11,
    y2: 177.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444B5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 60.625,
    x2: 47.545,
    y1: 32.505,
    y2: 152.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4D8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#4F5669"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444B5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 56.371,
    x2: 56.202,
    y1: 103.051,
    y2: 114.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#D4D8DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#757D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#1A1A1A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 57.364,
    x2: 53.41,
    y1: 31.382,
    y2: 175.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#2A59BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#274E9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#25437E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#233C66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#223758"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#223654"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 115.015,
    height: 120.393,
    x: 43.126,
    y: 20.152,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.91
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.639216 0 0 0 0 0.917647 0 0 0 0 0.164706 0 0 0 0.77 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7001_8843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7001_8843",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    width: 74.908,
    height: 50.376,
    x: 103.4,
    y: 0.713,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.79
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.32
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7001_8843"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7001_8843",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFasterMachinesmin);
export default __webpack_public_path__ + "static/media/faster-machines.min.c729331a9bad1692481ec7c513be6002.svg";
export { ForwardRef as ReactComponent };